export const ALL_DEFAULT_PREDEFINED_RANGES_KEYS = [
    'today',
    'yesterday',
    'last_7_days',
    'last_14_days',
    'last_30_days',
    'this_week',
    'last_week',
    'this_month',
    'last_month',
    'this_quarter',
    'last_quarter',
];
export const ALL_DEFAULT_RANGES_KEYS = [...ALL_DEFAULT_PREDEFINED_RANGES_KEYS, 'custom'];
export const DEFAULT_RANGES_LABELS_MAP = {
    today: 'Today',
    yesterday: 'Yesterday',
    last_7_days: 'Last 7 days',
    last_14_days: 'Last 14 days',
    last_30_days: 'Last 30 days',
    this_week: 'This week',
    last_week: 'Last week',
    this_month: 'This month',
    last_month: 'Last month',
    this_quarter: 'This quarter',
    last_quarter: 'Last quarter',
    custom: 'Custom',
};
//# sourceMappingURL=ComplexStaticDateRangePicker.constants.js.map